// 获取cookie
export const getCookie = (name) => {
    const re = new RegExp("\\b" + name + "=([^;]*)\\b");
    const arr = re.exec(document.cookie);
    return arr ? decodeURIComponent(arr[1]) : null;
};

// 设置cookie（expires既可以传距离当前时间的毫秒数，也可以传具体的日期对象）
export const setCookie = (name, value, expires, path, domain, secure) => {
    expires = expires || null;
    path = path || '/';
    domain = domain || null;
    secure = secure || false;
    let now = new Date();

    // 如果传入的expires值是毫秒数，则表示过期时间与当前时间的毫秒差
    if (typeof expires === 'number') {
        now.setTime(now.getTime() + Number(expires));
        expires = now;
    }
    document.cookie = name + "=" + encodeURIComponent(value) + (!expires ? "" : ("; expires=" + expires.toGMTString())) + (!path ? "" : ("; path=" + path)) + (!domain ? "" : ("; domain=" + domain)) + ((secure === true) ? "; secure" : "");
};
    
// 删除cookie
export const removeCookie = (name, path, domain) => {
    if(getCookie(name)){
        path = path || '/';
        document.cookie = name + '=' + '; expires=Thu, 01-Jan-70 00:00:01 GMT; path=' + path + (domain ? ('; domain=' + domain) : '');
    }
};
